import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { ADVANCED_SEARCH_FEATURE_TOGGLE } from './constants';

@Injectable()
export class CanAccessAdvancedSearchGuard {
  constructor(private router: Router, private store: Store) {}

  canActivate() {
    return this.store.select(getFeatureToggle(ADVANCED_SEARCH_FEATURE_TOGGLE)).pipe(
      map(isEnabled => {
        if (isEnabled) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      }),
      take(1)
    );
  }

  canActivateChild() {
    return this.canActivate();
  }
}
